module.exports = __webpack_public_path__ + "img/icon-group2.bf0d4864.svg";